import React from 'react'
import { useLocation } from 'react-router-dom'
import { useToast } from '../../utils/ToastContext'
import { usePageTitle } from '../../utils/usePageTitle'
import { useAuthCallback } from './useAuthCallback'

export const CallbackPage = () => {
	const location = useLocation()
	const { handleAuthCallback, navigateToLogin, isPending } = useAuthCallback()
	const { showToast } = useToast()
	const processed = React.useRef(false)

	usePageTitle()

	React.useEffect(() => {
		if (!processed.current) {
			processed.current = true
			const params = new URLSearchParams(location.search)
			handleAuthCallback(params).catch((error) => {
				// Handle errors from invalid authentication parameters
				const errorMessage = error instanceof Error ? error.message : 'Authentication failed. Please try again.'
				showToast(errorMessage, 'error')
				navigateToLogin()
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [handleAuthCallback, location.search, navigateToLogin, showToast])

	return (
		<div className='callback-container'>
			<h2>Completing authentication...</h2>
			<p>{isPending ? 'Please wait while we complete your login' : 'Redirecting...'}</p>
		</div>
	)
}
